module.exports = __webpack_public_path__ + "img/coeur_demi.f6c70413.png";